var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.mainFields.link?.value)?_c('div',{style:({
    'background-color': _vm.useBackgroundColor,
    'padding-top': _vm.paddingTop ? _vm.paddingTop + 'px' : '',
    'padding-bottom': _vm.paddingBottom ? _vm.paddingBottom + 'px' : ''
  })},[_c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('ui-link',{attrs:{"href":_vm.mainFields.link?.value}},[_vm._v("\n      "+_vm._s(_vm.mainFields.title?.value || _vm.mainFields.link?.value)+"\n    ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }